import { selector } from "recoil";
import userAtom from "stores/recoil/userAtom";

const userPermsSelector = selector({
  key: "@user_selector",
  get: async ({ get }) => {
    const perms = get(userAtom).permissions;
    const isAdmin = get(userAtom).is_administrator;
    const accessToProductSection = get(userAtom).is_sale_manager === 1;

    let userPerms: string[] = [];
    perms?.map((perm) => perm?.slug && userPerms.push(perm?.slug));

    return { isAdmin, userPerms, accessToProductSection };
  },
});

export default userPermsSelector;
